export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                 ID поста
  //--------------------------------------------------------------------------
  postId: {
    type: Number,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                    Отображать день/месяц (по дефолту часы/минуты)
  //----------------------------------------------------------------------------
  isDate: {
    type: Boolean,
    default: false,
    required: false,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});